// extracted by mini-css-extract-plugin
export default {"header":"awoDt","inner":"NBmxP","icon":"Bf_AG","label":"oRtKr","text":"L2nhI","triggerIcon":"wXFwb"};